import { Pipe, PipeTransform } from '@angular/core';
import * as d3 from 'd3';
import { RoutingService } from '../service/routing.service';

/**
 * This pipe defines the score color
 */

@Pipe({ name: 'colorScore' })
export class ColorScorePipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  constructor(_routing?: RoutingService) {}
  transform(value: string | number): string {
    const numericValue = parseFloat(String(value));
    if (value && !isNaN(numericValue) && numericValue !== 0) {
      const colorScale = d3
        .scaleThreshold<number, string>()
        .domain([2, 4, 6, 8])
        .range(['#50DF6A', '#FEF554', '#FFB347', '#FF7700', '#FF4C23']);
      return colorScale(numericValue) ?? 'rgb(120,120,120)';
    } else {
      return 'rgb(120,120,120)';
    }
  }
}
